// extracted by mini-css-extract-plugin
export default {"posi":"Tourdetail_posi__iQG3O"};